import React, {useState} from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import {Field} from 'react-final-form';
import Explanation_text from './Explanation_text';
import {connect} from 'react-redux';

function Select_component(props){
  const[err, setErr]=useState(undefined);
  let select_data=props.select_data;
  if(props.enum!=undefined && props.enumerations!=undefined && props.enumerations[props.enum]!=undefined){
    select_data=[];
    for(let es of props.enumerations[props.enum]){
      select_data.push({id:(props.enum_id==true)?es.id:es.value, value:(props.enum_id==true)?es.id:es.value, name:es.name});
    }
  }
  if(props.unshift_select_data!=undefined){
    for(let x of props.unshift_select_data){
      select_data.unshift(x);
    }
  }
  console.log(select_data, props, 'YOOYOYOYOYOYOYO')
  if(props.no_field==true){return(<SelectTool {...props} select_data={select_data}/>)}
  else{return(<Field name={props.name}>{(f)=>{
    if(err!=f.meta.error && f.meta.error!=''){setErr(f.meta.error);}
    return(<SelectTool {...props} select_data={select_data} error={(f.meta.error!='' && f.meta.error!=undefined)?true:props.error} helperText={(f.meta.error!='')?f.meta.error:props.helperText} value={f.input.value} onChangeExtra={props.onChange} onChange={f.input.onChange}/>)}}</Field>)}
}

function SelectTool(props) {

  return (
      <FormControl style={(props.style!=undefined)?{width:'calc(100% - 20px)', marginLeft:'10px', ...props.style, backgroundColor:(props.color=='transparent')?undefined:'#f7f9fc'}:{width:'calc(100% - 20px)', marginLeft:'10px', backgroundColor:(props.color=='transparent')?undefined:'#f7f9fc'}} variant={(props.variant=='not_outlined')?undefined:(props.variant==undefined)?'outlined':props.variant} size={(props.size==undefined)?'small':props.size}>
        <InputLabel id="demo-simple-select-label" style={{ background: 'inherit', padding:(props.title==undefined)?undefined:'0 5px', fontSize:undefined }}><Explanation_text inline text={props.title}/></InputLabel>
        <Select
          disabled={props.disabled}
          style={{fontSize:undefined}}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={props.value}
          onChange={(e)=>{console.log(e); props.onChange(e); if(props.onChangeExtra!=undefined){props.onChangeExtra(e);}}}
          required={props.required}
          error={(props.required_error==true && (props.value=='' || props.value==undefined || props.value==null))?true:props.error}
        >
        {(props.first_none==true)?<MenuItem value={undefined}>None</MenuItem>:null}
        {(props.first_unknown==true)?<MenuItem value={undefined}>Unknown</MenuItem>:null}
        {(props.select_data==undefined)?null:
          props.select_data.map(function(m, index){
            if(props.val_name_one==true){
              return(<MenuItem style={{fontWeight:(m.level===0)?'bold':'', paddingLeft:(m.level==undefined)?null:(m.level==0)?'16px':16+(m.level*30)+'px'}} value={(m.name!=undefined)?m.name:index}>{(m.level!=undefined && m.level!=0)?'- ':''}{(m.name!=undefined)?m.name:m}</MenuItem>)
            }else{
              return(<MenuItem style={{fontWeight:(m.level===0)?'bold':'', paddingLeft:(m.level==undefined)?null:(m.level==0)?'16px':16+(m.level*30)+'px'}} value={(m.value!=undefined)?m.value:m.id}>{(m.level!=undefined && m.level!=0)?'- ':''}{m.name}</MenuItem>)
            }
          })
        }
        </Select>
        <Typography varian='caption' style={{color:(props.error==true)?'red':undefined, marginLeft:'2px', fontSize:'10px'}}>{props.helperText}</Typography>
      </FormControl>
  );
}

export default connect(ss)(Select_component);


function ss(state){
  return{
    enumerations:state.account.enumerations
  }
}
